export const iconFontAwesomeArrowsUpRightAndDownLeftFromCenter = (
	<i className="fa-solid fa-up-right-and-down-left-from-center"></i>
);
